export const setCookie = ( name: string, value: any, days?: number ) => {
  let expires = '';
  if ( days ) {
    const date = new Date();
    date.setTime( date.getTime() + days * 24 * 60 * 60 * 1000 );
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

export const getCookie = ( name: string ) => {
  const nameEquals = `${name}=`;
  const ca = document.cookie.split( ';' );
  for ( let i = 0; i < ca.length; i += 1 ) {
    let c = ca[i];
    while ( c.charAt( 0 ) === ' ' ) c = c.substring( 1, c.length );
    if ( c.indexOf( nameEquals ) === 0 ) return c.substring( nameEquals.length, c.length );
  }
  return null;
};
